import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import useToast from 'hooks/useToast';
import { PaymentCard } from 'models/paymentCard';
import PaymentGroupCardSelect from 'screens/components/Payment/PaymentGroupCardSelection';
import { getAllPaymentCards, getGroupAllPaymentCards } from 'services/paymentMethodService';

interface Params {
  match: {
    params: {
      groupId?: string;
    };
  };
  showCardSelection?: boolean;
  onConfirmSelection?: (cardId?: string) => void;
}

const PaymentGroupCardSelectionContainer = ({ match: { params }, showCardSelection, onConfirmSelection }: Params) => {
  const history = useHistory();
  const toast = useToast();
  const [cardList, setCardList] = useState<PaymentCard[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cardSelected, setCardSelected] = useState<PaymentCard | undefined>();

  const getCardList = useCallback(async () => {
    setIsLoading(true);
    try {
      if (params.groupId) {
        const response = await Promise.all([getAllPaymentCards(), getGroupAllPaymentCards(params.groupId)]);

        const list = response[0].map((item) => item.card);
        setCardList(list);
        if (response[1].length > 0) {
          const pcard: PaymentCard = response[1][0];
          setCardSelected(pcard);
        } else {
          const result = response[0].filter((item) => item.card.defaultCC === true);
          if (result && result.length > 0) {
            setCardSelected(result[0].card);
          }
        }
      } else {
        const response = await getAllPaymentCards();

        const list = response.map((item) => item.card);
        setCardList(list);
        const result = response.filter((item) => item.card.defaultCC === true);
        if (result && result.length > 0) {
          setCardSelected(result[0].card);
        }
      }
    } catch (error) {
      toast.add({
        type: 'danger',
        message: error.message,
      });
    } finally {
      setIsLoading(false);
    }
  }, [params.groupId, toast]);

  useEffect(() => {
    getCardList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCloseSelectionScreen = () => {
    if (params.groupId) {
      history.push(`/corporate/group/${params.groupId}`);
      return;
    }
    history.goBack();
  };

  return (
    <PaymentGroupCardSelect
      showCardSelection={showCardSelection}
      groupId={params.groupId}
      cardSelected={cardSelected}
      cardList={cardList}
      isLoading={isLoading}
      onCloseSelectionScreen={onCloseSelectionScreen}
      onConfirmSelection={(cardId?: string) => {
        if (onConfirmSelection) onConfirmSelection(cardId);
      }}
    />
  );
};

export default PaymentGroupCardSelectionContainer;
